export const NO_CHANGES = 1;
export const UPDATE = 2;
export const DELETED = 3;

export const changeStatus = {
    1: 'Brak Zmian',
    2: 'Aktualizacja',
    3: 'Usunięto'
}